import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const workItemEmbedRoute: InvariantJiraRoute = {
	name: 'work-item-embed',
	path: '/jira/browse/:issueKey(\\w+-\\d+)/embed',
};
